import React, { useState } from "react";
import { ApiService, getUserType } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GGeoTagsInput from "../gComponents/gGeofencesInput";
import GButton from "../gComponents/gButton";
import useDataFctory from "../useDataFactory";

export default function EditStore(props) {
  const [openSnackbar] = useSnackbar();
  const { data: branchesData } = useDataFctory("branches", false);
  const { data: brandsData } = useDataFctory("brands", false);
  const [switchFeaturedVal, setSwitchFeaturedVal] = useState(
    props.data.featured === 1 ? true : false
  );
  const [switchStatusVal, setSwitchStatusVal] = useState(
    props.data.store_status === 1 ? true : false
  );
  const initialValues = {
    title: props.data.title || "",
    phone: props.data.phone || "",
    commission: props.data.commission || 0,
    order_type: props.data.order_type || "",
    delivery_type: props.data.delivery_type || "",
    min_order: props.data.min_order || "0",
    featured: props.data.featured || 0,
    store_status: props.data.store_status || 0,
    geofences: props.data.geofences || [],
    branch_id: props.data.branch_id || "",
    brand_id: props.data.brand_id || "",
    pack_time: props.data.pack_time || "",
    aerial_distance: props.data?.aerial_distance || "",
    aerialDistance: props.data ? (props.data.aerial_distance ? 1 : 0) : 0,
  };

  const deliveryTypes = [
    {
      title: "Both",
      value: "",
    },
    {
      title: "ASAP Only",
      value: "asap",
    },
    {
      title: "Scheduled Only",
      value: "scheduled",
    },
  ];

  const orderTypes = [
    {
      title: "Both",
      value: "",
    },
    {
      title: "Home Delivery",
      value: "home_delivery",
    },
    {
      title: "Store Pickup",
      value: "store_pickup",
    },
  ];

  const onSubmit = (values) => {
    let sendData = { ...values };
    sendData.featured = switchFeaturedVal === true ? 1 : 0;
    sendData.store_status = switchStatusVal === true ? 1 : 0;
    sendData.aerial_distance = sendData.aerial_distance || 0;
    console.log(sendData);
    // return;
    ApiService({
      method: "PUT",
      route: "stores/" + props.data.id,
      body: sendData,
    }).then((response) => {
      console.log("r" + response.data.status_code);
      if (response.data.status_code === 1) {
        props.setSevisible(false);
        props.onSubmit();
      }
      openSnackbar(response.data.message);
      return;
    });
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    phone: Yup.string()
      .test(
        "len",
        "Phone must be between 7 and 15 digits",
        (val) => val.length < 15 && val.length > 7
      )
      .required("Required"),
    commission: Yup.string().required("Required"),
    // latitude: Yup.string().required("Required"),
  });

  if (props.sevisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header"> Edit Store </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div
                style={{
                  margin: "-63px 10px 0px",
                  float: "right",
                  right: "20px",
                  position: "absolute",
                  display: "inline-flex",
                }}
              >
                <label
                  style={{
                    display: "inline-block",
                    fontSize: "0.98rem",
                    color: "#333",
                    padding: "5px",
                    fontStyle: "italic",
                    textDecoration: "underline",
                  }}
                >
                  Availability
                </label>
                <FormikControl
                  control="toggle"
                  isToggled={switchStatusVal}
                  name="store_status"
                  onToggle={() => {
                    setSwitchStatusVal(!switchStatusVal);
                  }}
                />
              </div>
              <br />
              <div style={{ display: "inline-flex" }}>
                <FormikControl
                  control="input"
                  type="text"
                  label="Title"
                  name="title"
                />
                <FormikControl
                  control="input"
                  type="text"
                  label="Phone"
                  name="phone"
                  onChange={(event) => {
                    const re = /^[0-9-+\b]+$/;
                    if (event.target.value && !re.test(event.target.value)) {
                      return;
                    } else {
                      setFieldValue("phone", event.target.value);
                    }
                  }}
                />
              </div>

              <h4
                style={{
                  padding: "15px 15px 10px",
                  fontSize: "18px",
                  fontWeight: "450",
                }}
              >
                Additional Information
              </h4>

              <div style={{ display: "inline-flex", width: "100%" }}>
                <FormikControl
                  control="input"
                  type="text"
                  label="Commission (in %)"
                  name="commission"
                />
                <FormikControl
                  control="input"
                  type="text"
                  label="Min Order"
                  name="min_order"
                />
              </div>
              {getUserType() && branchesData && (
                <FormikControl
                  control="select"
                  as="select"
                  label="Branches"
                  name="branch_id"
                  options={branchesData}
                  key_title="title"
                  key_value="id"
                  divstyle={{
                    display: "inline-block",
                    width: "50%",
                    boxSizing: "border-box",
                    verticalAlign: "top",
                  }}
                />
              )}

              {brandsData &&
                brandsData.length >= 0 &&
                props.settings?.brands_available == 1 && (
                  <FormikControl
                    control="select"
                    as="select"
                    label="Brand"
                    name="brand_id"
                    options={brandsData}
                    key_title="title"
                    key_value="id"
                    divstyle={{
                      display: "inline-block",
                      width: "50%",
                      boxSizing: "border-box",
                      verticalAlign: "top",
                    }}
                  />
                )}

              <div style={{ margin: "15px" }}>
                <label>Geofences</label>
                <GGeoTagsInput
                  data={values.geofences}
                  onSubmit={(tags) => {
                    console.log(tags);
                    values.geofences = tags.map((d) => d.id);
                  }}
                  showButton={false}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  margin: "0 15px",
                  minHeight: "55px",
                  alignItems: "center",
                }}
              >
                <label style={{ width: "140px" }}>Max Listing Distance</label>
                <FormikControl
                  control="toggle"
                  label=""
                  isToggled={values.aerialDistance}
                  name="serial_distance"
                  iconType="google"
                  onToggle={() => {
                    let unlimitedVal =
                      values.aerialDistance == 1 ? true : false;
                    unlimitedVal = !unlimitedVal;
                    unlimitedVal = unlimitedVal === true ? 1 : 0;
                    setFieldValue("aerialDistance", unlimitedVal);
                  }}
                />
                {values.aerialDistance === "1" ||
                values.aerialDistance === 1 ? (
                  <FormikControl
                    control="input"
                    type="text"
                    name="aerial_distance"
                    className="noBorder noMargin"
                    style={{ width: "170px" }}
                    onChange={(event) => {
                      const re = /^[0-9\b]+$/;
                      if (event.target.value && !re.test(event.target.value)) {
                        return;
                      } else {
                        setFieldValue("aerial_distance", event.target.value);
                      }
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div style={{ margin: "10px 15px 10px" }}>
                <label
                  style={{
                    display: "inline-block",
                    fontSize: "0.98rem",
                    color: "#333",
                    paddingRight: "15px",
                  }}
                >
                  Featured
                </label>
                <FormikControl
                  control="toggle"
                  isToggled={switchFeaturedVal}
                  name="featured"
                  onToggle={() => {
                    setSwitchFeaturedVal(!switchFeaturedVal);
                  }}
                />
              </div>

            
              <br />
              <GButton
                type="submit"
                variant="condensed"
                children={props.data ? "Update" : "Create"}
                style={{ margin: "0 15px", width: "calc(100% - 30px)" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
}
